<template>
    <div class="card">
        <div>
            <div class="row">
                <div class="col-lg-9 col-sm-8">
                    <div class="p-4">
                        <h5 class="text-primary">Connect your {{ socialNetwork }} {{ socialNetwork === 'Google Analytics' ? '' : 'profile'}}</h5>
                        <p>Connect your social media profile to be visible to clients that wants to hire you and to see useful information like: </p>

                        <div class="text-muted">
                            <p class="mb-1">
                                <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                                {{ $t('Your post engagement data.') }}
                            </p>
                            <p class="mb-1">
                                <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                                {{ $t('Popularity of your profile.') }}
                            </p>
                            <p class="mb-0">
                                <i class="mdi mdi-circle-medium align-middle text-primary mr-1"></i>
                                {{ $t('Your audience data.') }}
                            </p>
                        </div>

                        <div class="mt-4">
                            <button @click="connect" class="btn btn-primary"> {{ $t('Connect') }} {{ socialNetwork }} </button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-4 align-self-center">
                    <div class="connect-card">
                        <img
                                :src="require(`@/assets/images/brands/${socialNetwork.toLowerCase().replace(/ /g, '-')}.png`)"
                                alt
                                class="img-fluid d-block connect-image"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "connectCard",
        props: {
            socialNetwork: {
                type: String,
                required: true,
                default: 'Social Network'
            },
        },
        methods: {
            connect () {
                this.$emit('connect');
            }
        }
    }
</script>

<style scoped>
    .card {
        overflow: hidden;
    }
    .connect-card {
        max-width:230px;
        margin-left:auto;
    }
    .connect-image {
        position:relative;
        bottom:-50px;
        right: -20px;
    }
</style>
